import statusService from "api/statusService";
import taskService, { IUpdateTaskPayload } from "api/taskService";
import AdditionalClientModal from "components/AdditionalClientModal";
import Button from "components/Button";
import ChooseTagNew from "components/ChooseTagNew";
import DatePickerNew, { DateSidePick } from "components/DatePickerNew";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import SearchCasesNew from "components/SearchCasesNew";
import SearchMemberNew from "components/SearchMemberNew";
import SelectFlagNew from "components/SelectFlagNew";
import TextArea from "components/TextArea";
import ActionsContext from "contexts/ActionsContext";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { IFeed } from "dto/IFeed";
import { IStatus } from "dto/IStatus";
import { ITag } from "dto/ITag";
import { IWorkspaceMember } from "dto/IWorkspace";
import { Formik } from "formik";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import styles from "./styles.module.scss";
import { FC, InitialValues, Props } from "./typings";
import { validationSchema } from "./validation.schema";

import CloseIcon from "assets/icons/close.svg?react";
import Chip from "components/Chip";
import { Avatar } from "@mui/material";
import { convertToLetters } from "utils/convertToLetters";
import { useTranslation } from "react-i18next";

const ActionModal: FC<Props> = ({ initialState, onChange, pack }) => {
  const { t } = useTranslation();
  const [Case, setCase] = useState<ICaseSimple | null>(null);
  const { mutate: createTask, isLoading: isCreateTask } =
    taskService.useUpdateTask();
  const { mutate: updateTask, isLoading: isUpdateTask } =
    taskService.useNewUpdateTask();
  const { mutate: setStatus } = statusService.useSetStatus();
  const [selectedStatus, setSelectedStatus] = useState<IStatus | null>(null);

  const isLoading = isCreateTask || isUpdateTask;

  const { tasks, setTasks } = useContext(ActionsContext);

  const [tags, setTags] = useState<ITag[]>([]);
  const [members, setMembers] = useState<IWorkspaceMember[]>([]);

  const [isPackage, setIsPackage] = useState<string | null>(null);

  useEffect(() => {
    const pack = sessionStorage.getItem("action");
    if (pack?.length) {
      setIsPackage(pack);
      sessionStorage.removeItem("action");
    }
  }, []);

  const handleClick = (values: InitialValues) => {
    let packId: string | null = null;
    let packKind: string | null = null;

    if (isPackage) {
      const p = isPackage.split(":");
      packId = p[1];
      packKind = p[2];
    }

    if (pack) {
      packId = pack.Id;
      packKind = String(pack.Kind);
    }

    const isAllDay = moment(values.startDate).format("HH:mm") === "00:00";

    const payload: IUpdateTaskPayload = {
      OwnerId: packId ? packId : values?.case ? values.case!.Id : "",
      OwnerKind: packKind
        ? Number(packKind)
        : values?.case
        ? values.case!.Kind
        : 0,
      Allday: isAllDay,
      FromDate: moment(values.startDate).toISOString(true),
      Id: initialState ? initialState.id : null,
      IsFavourite: true,
      Title: values.title,
      Note: values.text,
      TagIds: tags.map((tag) => tag.Id),
      ToDate: values.endDate ? moment(values.endDate).toISOString(true) : null,
    };

    if (members.length) {
      payload.WorkspaceId = getWorkspaceId() ?? "";
      payload.ForUserId = members[0].UserId;
    }
    // if (values.member) {
    //   payload.WorkspaceId = getWorkspaceId() ?? '';
    //   payload.ForUserId = values.member.UserId;
    // }

    if (initialState?.id) {
      updateTask(payload, {
        onSuccess: (response) => {
          if (onChange) {
            closeModal();
            onChange(response.data);
            return;
          }
        },
      });

      return;
    }

    createTask(payload, {
      onSuccess: (response) => {
        if (onChange) {
          closeModal();
          onChange(response.data);
          return;
        }

        const task: IFeed = {
          IsFavourite: false,
          note: response.data.Note ?? "",
          allDay: response.data.AllDay,
          AllDay: response.data.AllDay,
          id: response.data.Id,
          Id: response.data.Id,
          title: response.data.Title ?? "",
          description: response.data.Note ?? "",
          Note: response.data.Note ?? "",
          caseId: values?.case?.Id ?? undefined,
          Case: response.data.Case,
          FromDate: moment(response.data.FromDate).toISOString(true),
          ToDate: response.data.ToDate
            ? moment(response.data.ToDate).toISOString(true)
            : moment(response.data.FromDate)
                .endOf("day")
                .add(1, "m")
                .toISOString(true),
          start: moment(response.data.FromDate).toDate(),
          end: response.data.ToDate
            ? moment(response.data.ToDate).toDate()
            : moment(response.data.FromDate).endOf("day").add(1, "m").toDate(),
          TagIds: response.data.TagIds,
          StatusId: selectedStatus?.Id as number,
          statusId: selectedStatus?.Id as number,
        };
        setTasks([task, ...tasks]);
        if (selectedStatus) {
          setStatus(
            {
              OwnerId: response.data.Id,
              OwnerKind: 131072,
              StatusId: selectedStatus?.Id as number,
            },
            {
              onSuccess: () => {
                closeModal();
              },
            },
          );
        } else {
          closeModal();
        }
      },
    });
  };

  const closeModal = () => {
    // setModals({ ...modals, hide: true });
    // onChange?.(null);
  };

  const initialValues = {
    case: null,
    title: "",
    text: "",
    startDate: new Date(),
    endDate: new Date(),
    member: null,
  };

  const [selected, setSelected] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCase, setShowCase] = useState(false);

  const refWrapper = useRef(null);

  const showRight = showCalendar || showCase;

  return (
    // Jeżeli będzie potrzeba to tą zawartość wynieśc do funkcji build i w ten sposób obsłużyć okna modalne
    <Formik
      validationSchema={validationSchema}
      onSubmit={() => {}}
      initialValues={initialValues as InitialValues}
    >
      {({ values, setFieldValue, setFieldTouched }) => {
        return (
          <ModalLayout
            dock={DockPosition.DISABLED}
            off={true}
            customX={8}
            customY={0}
            ignore
            refWrapper={refWrapper}
            isAnimation
            fullHeight={true}
            name="createTask"
            disableMove={true}
          >
            <>
              {/* <CaseObserver /> */}
              <div className={styles.wrap}>
                <div
                  className={`${styles.window} ${
                    showCalendar && styles.disableBorder
                  }`}
                >
                  <div className={styles.wrapper}>
                    <div className={styles.title}>
                      {t("modals.newEvent")}
                      <CloseIcon
                        onClick={closeModal}
                        className={styles.closeIcon}
                      />
                    </div>

                    <div className={styles.content}>
                      <div className={styles.topBar}>
                        <div className={styles.left}>
                          <SelectFlagNew
                            selectedStatus={selectedStatus}
                            onChoose={(s) => setSelectedStatus(s)}
                          />

                          {!showCalendar && (
                            <DatePickerNew
                              showTime
                              startOf={values.startDate}
                              endOf={values.endDate}
                              setDate={(type, date) => {
                                if (type === 1) {
                                  setFieldValue("startDate", date);

                                  if (values.startDate === null) {
                                    setFieldValue(
                                      "endDate",
                                      moment(date).add(30, "minutes").toDate(),
                                    );
                                  }

                                  if (moment(date).isAfter(values.endDate)) {
                                    setFieldValue(
                                      "endDate",
                                      moment(date).add(30, "minutes").toDate(),
                                    );
                                  }
                                }
                                if (type === 2) {
                                  setFieldValue("endDate", date);

                                  if (moment(date).isBefore(values.startDate)) {
                                    setFieldValue(
                                      "startDate",
                                      moment(date).toDate(),
                                    );
                                  }
                                }
                              }}
                            />
                          )}
                        </div>
                        <div className={styles.right}>
                          {/* <div
                            onClick={() => {
                              setShowCalendar(!showCalendar);
                            }}
                            className={styles.icon}
                          >
                            {showCalendar ? <HideIcon /> : <ShowIcon />}
                          </div> */}
                        </div>
                      </div>
                      <div className={styles.input}>
                        {!isPackage && (
                          <SearchCasesNew
                            settedCase={values.case}
                            onBlur={() => setFieldTouched("case", true)}
                            setAddNewEntity={() => {
                              setShowCase(true);
                            }}
                            onChoose={(cas) => {
                              setFieldValue("case", cas);
                              setFieldTouched("case", true);
                            }}
                          />
                        )}
                      </div>
                      <TextArea
                        focus
                        className={styles.input}
                        onBlur={() => setFieldTouched("title", true)}
                        value={values.title}
                        onChange={(t) => {
                          setFieldValue("title", t);
                        }}
                        label={t("forms.title")}
                      />
                      <TextArea
                        onBlur={() => setFieldTouched("text", true)}
                        className={styles.input}
                        value={values.text}
                        label={t("actions.eventDescription")}
                        onChange={(text) => {
                          setFieldValue("text", text);
                        }}
                        minRows={2}
                      />

                      <div className={styles.controls}>
                        <ChooseTagNew
                          type={0}
                          onChoose={(tag) => {
                            const isExist = tags.find(
                              (t) => t.Name === tag?.Name,
                            );

                            if (isExist) return;

                            setTags([...tags, tag!]);
                          }}
                        />

                        <SearchMemberNew
                          onChoose={(member) =>
                            setMembers([...members, member as IWorkspaceMember])
                          }
                        />
                      </div>

                      <div className={styles.list}>
                        {!!tags.length && (
                          <div className={styles.tags}>
                            {tags.map((tag) => (
                              <Chip
                                element={<>{tag.Name}</>}
                                onDelete={() => {
                                  setTags(tags.filter((t) => t.Id !== tag.Id));
                                }}
                              />
                            ))}
                          </div>
                        )}
                        <div className={styles.members}>
                          {members.map((member) => (
                            <Chip
                              avatar={
                                <Avatar className={styles.avatar}>
                                  {convertToLetters(member.Label)}
                                </Avatar>
                              }
                              element={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  {member.Label}
                                </div>
                              }
                              onDelete={() => {
                                setMembers(
                                  members.filter((f) => f.Id !== member.Id),
                                );
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className={styles.footer}>
                      <div className={styles.buttonWrapper}>
                        <Button
                          loading={isLoading}
                          disabled={!values.title.length}
                          // disabled={
                          //   isPackage
                          //     ? !values.title.length
                          //     : !values.case || !values.title.length
                          // }
                          className={styles.button}
                          //  handleError={handleError}
                          onClick={() => handleClick(values)}
                          text={
                            initialState?.Id
                              ? t("common.save")
                              : t("actions.new")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {showRight && (
                  <div className={styles.datePicker}>
                    <AdditionalClientModal
                      showActionModal
                      component={
                        <div className={styles.card}>
                          <DateSidePick
                            selected={selected}
                            setDate={(type, date) => {
                              if (type === 1) {
                                setFieldValue("startDate", date);
                              }
                              if (type === 2) {
                                setFieldValue("endDate", date);
                              }
                            }}
                            setSelected={setSelected}
                            startOf={values.startDate}
                            endOf={values.endDate}
                          />
                        </div>
                      }
                      showCase={showCase}
                      onCreateCase={(c) => {
                        setCase(c);
                        setShowCase(false);
                      }}
                    />
                  </div>
                  // <div className={styles.datePicker}>
                  //   <DateSidePick
                  //     selected={selected}
                  //     setDate={(type, date) => {
                  //       if (type === 1) {
                  //         setFieldValue('startDate', date);
                  //       }
                  //       if (type === 2) {
                  //         setFieldValue('endDate', date);
                  //       }
                  //     }}
                  //     setSelected={setSelected}
                  //     startOf={values.startDate}
                  //     endOf={values.endDate}
                  //   />
                  // </div>
                )}
              </div>
            </>
          </ModalLayout>
        );
      }}
    </Formik>
  );
};

export default ActionModal;
